export enum DATADOG_ACTIONS {
  SAVE_DIAPO = 'SAVE DIAPO ...',
  SAVE_ARTICLE = 'SAVE ARTICLE ...',
}
